import React from "react";

import TextFieldController from "../forms/TextFieldController";
import UploadButton from "../forms/UploadButton";

const ProjectForm = ({ control, register, estateId, setValue, defaultSelectedDoc }) => {
  return (
    <>
      <div className="row">
        <label className="form-group-label text-red">Logo promoteur</label>
        <UploadButton
          label="Uploader une image"
          register={register}
          sx={{ backgroundColor: "var(--red-color)" }}
          estateId={estateId}
          setValue={setValue}
          defaultSelectedDoc={defaultSelectedDoc}
        />
      </div>
      <div className="row">
        <label className="form-group-label">
          Date<span>*</span>
        </label>
        <TextFieldController control={control} name="project.date" disabled />
      </div>
      <div className="row">
        <label className="form-group-label">
          Nom du projet<span>*</span>
        </label>
        <TextFieldController control={control} name="project.name" disabled />
      </div>
      <div className="row">
        <label className="form-group-label">
          Adresse<span>*</span>
        </label>
        <TextFieldController
          control={control}
          name="project.address"
          disabled
        />
      </div>
      <div className="row">
        <label className="form-group-label">
          Ville<span>*</span>
        </label>
        <TextFieldController
          control={control}
          name="project.country"
          disabled
        />
      </div>
      <div className="row">
        <div className="col">
          <label className="col-sm-12 form-group-label">
            Prénom<span>*</span>
          </label>
          <div className="col-sm-12">
            <TextFieldController
              control={control}
              name="project.owner.firstName"
              disabled
            />
          </div>
        </div>
        <div className="col">
          <label className="col-sm-12 form-group-label">
            Nom<span>*</span>
          </label>
          <div className="col-sm-12">
            <TextFieldController
              control={control}
              name="project.owner.name"
              disabled
            />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <label className="col-sm-12 form-group-label">
            GSM<span>*</span>
          </label>
          <div className="col-sm-12">
            <TextFieldController
              control={control}
              name="project.owner.phoneNumber"
              disabled
            />
          </div>
        </div>
        <div className="col">
          <label className="col-sm-12 form-group-label">
            Email<span>*</span>
          </label>
          <div className="col-sm-12">
            <TextFieldController
              control={control}
              name="project.owner.email"
              disabled
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ProjectForm;
